// Function to check and apply upload aside styling
function checkUploadAside() {
  const asideFrame = document.getElementById('aside-frame');
  if (!asideFrame) return;

  const asideContent = asideFrame.innerHTML;

  // Check if any non-search aside is loaded (Upload, Share, Domains, Watermark, Customize)
  // Updated to work with new card headers that include icons
  if (
    asideContent.includes('<h3>') && (
      asideContent.includes('bi-cloud-upload-fill') || // Upload
      asideContent.includes('bi-share-fill') || // Share
      asideContent.includes('bi-globe') || // Domains
      asideContent.includes('bi-image-fill') || // Watermark
      asideContent.includes('bi-sliders') // Customize
    )
  ) {
    document.body.classList.add('upload-aside-active');
  } else {
    document.body.classList.remove('upload-aside-active');
  }
}

// Check on initial page load
document.addEventListener('DOMContentLoaded', checkUploadAside);

// Unified aside layout handler for all non-search asides
document.addEventListener('turbo:frame-load', function(event) {
  if (event.target.id === 'aside-frame') {
    checkUploadAside();
  }
});

// Remove the class when the aside is cleared
document.addEventListener('turbo:frame-load', function(event) {
  if (event.target.id === 'aside-frame' && event.target.innerHTML.trim() === '') {
    document.body.classList.remove('upload-aside-active');
  }
}); 